import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dummy from "./pages/Dummy";
import SignUpPage from "./pages/SignUpPage";
import PropertyPage from "./pages/PropertyPage";
import Dummy2 from "./pages/Dummy2";

import PropertyEvaluationPage from "./pages/PropertyEvaluationPage";
import Dashboard from "./features/dashboard/component/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLoggedInUserAsync,
  fetchLoggedInUserInfoAsync,
} from "./features/user/userSlice";
import {
  selectAuthToken,
  selectLoggedInUser,
  setCredentials,
} from "./features/auth/authSlice";
import Protected from "./features/auth/component/Protected";
import PageNotFound from "./pages/404";
import LandingPage from "./pages/LandingPage";
import Logout from "./features/auth/component/Logout";
import ForgetPassword from "./features/auth/component/ForgotPassword";
import PartyDetailsPage from "./pages/PartyDetailPage";
import VirtualOrPhysicalModal from "./features/modal/VirtualOrPhysicalModal";
import RegistrationSuccessModal from "./features/modal/RegistrationSuccessModal";
// import OnlinePayment from "./features/Payment/component/OnlinePayment";
import AadhaarOTPModal from "./features/modal/AadhaarOTPModal";
import ConstructionModal from "./features/modal/ResidentialModal";
import CommercialDetailsModal from "./features/modal/CommercialModal";
import useIdleTimer from "./features/AutoLogout/useIdleTimer";
// import OnlineAppointment from "./features/OnlineAppointment/component/OnlineAppointment";
import ConfirmationModal from "./features/modal/ConfirmationModal";
import ESign from "./features/eSign/component/eSign";
import TypewriterAnimation from "./features/Loader/TypewriterAnimation";
import { ToastProvider } from "./features/Toast/ToastContext";
import AppointmentDashboard from "./AppointmentDashboard";
import EkycModal from "./features/modal/EkycModal";
import PartySignUp from "./features/modal/PartySignUpModal";
import SignUpNew from "./features/auth/component/SignUpNew";
import SignUpTest from "./features/auth/component/SignUpTest";
import MobileEmailModal from "./features/modal/MobileEmailModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OnlinePaymentPage from "./pages/OnlinePaymentPage";
import OnlineAppointmentPage from "./pages/OnlineAppointmentPage";
import Profile from "./pages/Profile";
import ViewSignedDoc from "./pages/ViewSignedDoc";
import UploadDocument from "./features/uploadDocument/UploadDocument";

import GovtOfficialForm from "./features/NewRegistration/GovtOfficialForm";
import AdvocateForm from "./features/NewRegistration/AdvocateForm";
import ServiceProviderLogin from "./features/AuthorityLogin/ServiceProviderLogin";
import ServiceProviderSignupForm from "./features/NewRegistration/ServiceProviderSignupFrom";
import FormUploader from "./pages/FormUploader";
import ReviewApproval from "./features/ReviewApproval/component/ReviewApproval";
import ReviewApprovalPage from "./pages/ReviewApprovalPage";

// Handles "back"/"forward" into /Login by clearing session
function SessionExpiryHandler() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navType = useNavigationType(); // "POP" = back/forward

  useEffect(() => {
    if (navType === "POP" && location.pathname === "/Login") {
      dispatch(setCredentials({ token: null, user: null }));
      localStorage.removeItem("authToken");
      sessionStorage.clear();
    }
  }, [navType, location.pathname, dispatch]);

  return null;
}

function App() {
  const dispatch = useDispatch();
  const user = useSelector(selectLoggedInUser);
  const token = useSelector(selectAuthToken);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user && token) {
      setIsLoading(true);
      dispatch(fetchLoggedInUserInfoAsync(user.email)).finally(() =>
        setIsLoading(false)
      );
    }
  }, [dispatch, user]);

  return (
    <>
      <BrowserRouter>
        <SessionExpiryHandler />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/Login" element={<LoginPage />} />
          <Route path="/SignUp" element={<SignUpPage />} />
          <Route path="/FormUploader" element={<FormUploader />} />
          <Route path="/GovtOfficialForm" element={<GovtOfficialForm />} />
          <Route path="/AdvocateForm" element={<AdvocateForm />} />
          <Route
            path="/ServiceProviderLogin"
            element={<ServiceProviderLogin />}
          />
          <Route
            path="/ServiceProviderSignupForm"
            element={<ServiceProviderSignupForm />}
          />
          <Route path="/Logout" element={<Logout />} />
          <Route path="/ForgetPassword" element={<ForgetPassword />} />
          <Route path="/AadhaarOTPModal" element={<AadhaarOTPModal />} />
          <Route
            path="/AppointmentDashboard"
            element={<AppointmentDashboard />}
          />
          <Route path="/MobileEmailModal" element={<MobileEmailModal />} />
          <Route path="/ViewSignedDoc" element={<ViewSignedDoc />} />
          <Route path="/SignUpTest" element={<SignUpTest />} />
          {/* <Route path="/Profile" element={<Profile />} /> */}

          {/* <Route path="/ConfirmationModal" element={<ConfirmationModal />} />
           <Route
            path="/VirtualOrPhysicalModal"
            element={<VirtualOrPhysicalModal />}
          /> */}
          <Route
            path="/Dashboard"
            element={
              <Protected>
                <Dashboard />
              </Protected>
            }
          />
          <Route
            path="/Profile"
            element={
              <Protected>
                <Profile />
              </Protected>
            }
          />
          <Route
            path="/Property"
            element={
              <Protected>
                <PropertyPage />
              </Protected>
            }
          />
          <Route
            path="/PropertyEvaluationPage"
            element={
              <Protected>
                <PropertyEvaluationPage />
              </Protected>
            }
          />
          <Route
            path="/PartyDetails"
            element={
              <Protected>
                <PartyDetailsPage />
              </Protected>
            }
          />
          <Route
            path="/ReviewApproval"
            element={
              <Protected>
                <ReviewApprovalPage />
              </Protected>
            }
          />
          <Route
            path="/OnlinePayment"
            element={
              <Protected>
                <OnlinePaymentPage />
              </Protected>
            }
          />
          <Route
            path="/OnlineAppointment"
            element={
              <Protected>
                <OnlineAppointmentPage />
              </Protected>
            }
          />
          <Route
            path="/eSign"
            element={
              <Protected>
                <ESign />
              </Protected>
            }
          />
          <Route
            path="/UploadDocument"
            element={
              <Protected>
                <UploadDocument />
              </Protected>
            }
          />
          {/* <Route
            path="/ViewSignedDoc"
            element={
              <Protected>
                <ViewSignedDoc />
              </Protected>
            }
          /> */}
          <Route path="*" element={<PageNotFound></PageNotFound>} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
